module.exports = __webpack_public_path__ + "static/media/03_01_01.ec15b95a.png";